import React, { Component } from 'react';
import axios from 'axios';
import config from '../../../config';
import MenuItem from '../../components/management/smsManager/MenuItem';
import Modal from '../../commons/Modal/Modal';
import FloatingActionButton from '../../commons/Buttons/FloatingActionButton';
import { TextInputField, TextAreaField } from '../../commons/Inputs';
import SMSList from '../../components/management/smsManager/tabs/SMSList';
import SMSHistoryList from '../../components/management/smsManager/tabs/SMSHistoryList';

let $ = window.jQuery;

export default class Index extends Component {
    state = {
        menu : [
            {
                link: '#sms-templates',
                label: 'SMS Templates'
            },
            {
                link: '#sms-history',
                label: 'SMS History'
            }
        ],
        smsTemplates: [],
        smsHistories: [],
        isSaving: false,
        title: '',
        content: '',
        selectedTemplateId: 0
    };

    deleteSMSTemplate = (id) => {
        let url = `${config.apiUrl}sms-templates/${id}`;

        axios.delete(url).then((res) => {
            $('#smsTemplateTable').dataTable().fnDestroy();
            this.getSMSTemplates();
        });
    };

    updateSMSTemplate = () => {
        let url = `${config.apiUrl}sms-templates/${this.state.selectedTemplateId}`;

        let data = {
            title: this.state.title,
            content: this.state.content
        };

        this.setState({
            isSaving: true
        });

        axios.put(url, data).then((res) => {
            $('#smsTemplateModal').modal('hide');

            this.setState({
                isSaving: false
            });

            $('#smsTemplateTable').dataTable().fnDestroy();
            this.getSMSTemplates();

            this.props.showNotification('success', 'SMS Template Updated');
        }).catch((error) => {
            $('#smsTemplateModal').modal('hide');

            this.setState({
                isSaving: false
            });

            this.props.showNotification('error', 'SMS Template Failed to Updated');
        });
    };

    handleEditSMSTemplate = (e) => {
        let id = e.target.dataset.id;
        let index = this.state.smsTemplates.findIndex((template) => {
            return parseInt(template.id, 10) === parseInt(id, 10);
        });

        this.setState({
            title: this.state.smsTemplates[index].title,
            content: this.state.smsTemplates[index].content,
            selectedTemplateId: id
        }, () => {
            $('#smsTemplateModal').modal('show');
        });
    };

    generateTableActions = (id) => {
        return (
            <div className="">
                <button href="#"
                        className='btn btn-xs tooltips green'
                        data-container="body"
                        data-placement="top"
                        data-original-title='Edit'
                        onClick={this.handleEditSMSTemplate}
                        data-id={id}>

                    <i className='glyphicon glyphicon-edit'
                       data-id={id} />
                </button>
                <button href="#"
                        className='btn btn-xs tooltips deletePopover red'
                        data-container="body"
                        data-placement="top"
                        data-original-title='Delete'
                        data-id={id}
                        data-toggle="confirmation"
                        data-singleton="true">

                    <i className='glyphicon glyphicon-remove'
                       data-id={id} />
                </button>
            </div>
        );
    };

    getSMSTemplates = () => {
        let url = config.apiUrl + 'sms-templates';

        axios.get(url).then((res) => {
            let displayData = res.data.data;

            displayData.forEach((row) => {
                // add actions
                row.actions = this.generateTableActions(row.id);
            });

            console.log(displayData);

            this.setState({
                smsTemplates: displayData
            }, () => {
                // eslint-disable-next-line
                $('#smsTemplateTable').DataTable({
                    "columnDefs": [
                        {
                            "targets": [0], //id
                            "visible": false,
                            "searchable": false
                        },
                        {
                            "targets": [3],
                            "width": 100
                        }
                    ],
                    "order": [[ 0, 'desc' ]]
                });

                $('.tooltips').tooltip();

                let self = this;

                $('.deletePopover').confirmation({
                    title: 'Are you sure to delete this SMS Template?',
                    popout: true,
                    btnOkClass: 'btn btn-primary btn-sm',
                    btnCancelClass: 'btn btn-danger btn-sm',
                    container: 'body',
                    onConfirm: function() {
                        let templateId = $(this).data('id');
                        self.deleteSMSTemplate(templateId);
                    }
                });
            });
        });
    };

    getSMSHistories = () => {
        let url = config.apiUrl + 'sms-histories';

        axios.get(url).then((res) => {
            let displayData = res.data.data;

            displayData.forEach((row) => {
                // add actions
                row.receiver = `${row.user.firstname} ${row.user.lastname}`;
            });

            console.log(displayData);

            this.setState({
                smsHistories: displayData
            }, () => {
                // eslint-disable-next-line
                $('#smsHistoryTable').DataTable({
                    "columnDefs": [
                        {
                            "targets": [0], //id
                            "visible": false,
                            "searchable": false
                        }
                    ],
                    "order": [[ 0, 'desc' ]]
                });

                $('.tooltips').tooltip();
            });
        });
    };

    handleFABClick = () => {
        $('#smsTemplateModal').modal('show');
    };

    handleCloseModal = (e) => {
        this.setState({
            title: '',
            content: '',
            selectedTemplateId: 0
        });
    };

    handleSaveSMSTemplate = (e) => {
        if (this.state.selectedTemplateId !== 0) {
            this.updateSMSTemplate();

            return;
        }

        let data = {
            title: this.state.title,
            content: this.state.content
        };

        let url = config.apiUrl + 'sms-templates';

        this.setState({
            isSaving: true
        });

        axios.post(url, data).then((res) => {
            $('#smsTemplateTable').dataTable().fnDestroy();
            this.getSMSTemplates();

            this.setState({
                isSaving: false,
                title: '',
                content: ''
            });

            $('#smsTemplateModal').modal('hide');
            this.props.showNotification('success', 'New SMS Template was added');
        }).catch((error) => {
            console.log(error);

            this.setState({
                isSaving: false
            });

            this.props.showNotification('error', 'Failed in creating SMS Template');
        });
    };

    handleTextChange = (e) => {
        let state = {};
        state[e.target.id] = e.target.value;

        this.setState(state);
    };

    componentDidMount() {
        this.getSMSTemplates();
        this.getSMSHistories();
    }

    render() {
        return (
            <div className="page-content">
                <div className="row">
                    <div className="col-md-12">
                        <div className="settings-content">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="portlet light">
                                        <div className="portlet-title tabbable-line">
                                            <div className="caption">
                                                <i className="icon-settings font-blue" />
                                                <span className="caption-subject font-blue sbold uppercase">SMS Manager</span>
                                            </div>

                                            <ul className="nav nav-tabs">
                                                {this.state.menu.map((item, i) => {
                                                    return <MenuItem {...item} key={i} index={i} />
                                                })}
                                            </ul>
                                        </div>
                                        <div className="portlet-body">
                                            <div className="tab-content">

                                                <div className="tab-pane active" id="sms-templates">
                                                    <SMSList smsTemplates={this.state.smsTemplates} />
                                                </div>

                                                <div className="tab-pane" id="sms-history">
                                                    <SMSHistoryList smsHistories={this.state.smsHistories} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="col-md-12">
                    <FloatingActionButton
                        title="Add SMS Template"
                        onClick={this.handleFABClick} />
                </div>

                <Modal
                    id="smsTemplateModal"
                    header="SMS Template"
                    onNegativeClickEvent={this.handleCloseModal}
                    onPositiveClickEvent={this.handleSaveSMSTemplate}
                    isSaving={this.state.isSaving}>

                    <div className="row">
                        <div id="alert-modal-container-pt"
                             style={{ paddingRight: '20px', paddingLeft: '20px' }}></div>

                        <div className="col-md-12">
                            <form id="smsTemplateForm">
                                <div className="row">
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <TextInputField val={this.state.title} id="title"
                                                        onChange={this.handleTextChange}
                                                        label="Title" help="Input Title"/>
                                    </div>
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <TextAreaField val={this.state.content} id="content"
                                                       maxlength="1000"
                                                       onChange={this.handleTextChange}
                                                       label="Content" help="Input Content"/>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </Modal>

            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/containers/SMSManager/index.js
 **/